import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/product.service';
import { SesionService } from '../../services/sesion.service';
import { environment } from '../../../environments/environment';
import { FormloginService } from 'src/app/services/formlogin.service';
import { ChangeService } from 'src/app/services/change.service';
import { BrokerService } from 'src/app/services/broker.service';
import { ActivatedRoute } from '@angular/router';
import { DataLayerService } from 'src/app/services/data-layer.service';
import { MetadatosService } from 'src/app/services/metadatos.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

declare var $: any;

@Component({
  selector: 'app-secure',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  //tempo
  urlEnv: any;
  questionPar: any;
  actualizacion: any;
  prevOtpL!:[number,string];
  otpCode:string[]=["","","","","",""];
	maintenanceAlert = false;
	maintenanceAlert2 = true;

	// IAM
	public hideContra = true;
	public hideConfirm = true;
	public caracteres = false;
	public upperLower = false;
	public unNumero = false;
	public unEspecial = false;
	public contrasena = '';

  constructor(
    public content: ProductService,
    public sesion: SesionService,
    public login: FormloginService,
    public broker: BrokerService,
    public cs: ChangeService,
    private activatedRoute: ActivatedRoute,
    private metadatosService: MetadatosService,
    private dataLayerService: DataLayerService,
    private utilities: UtilitiesService) {
      
    this.activatedRoute.queryParams.subscribe( (params): any => {
      this.questionPar = params['question'];
      this.actualizacion = params['auto'];
    });

    if (this.sesion.product === 'bc') {
      this.urlEnv = environment.validLogin_bc;
      this.sesion.setTitle('Acceder - Buscacrédito');
    }
    if (this.sesion.product === 'midc') {
      this.urlEnv = environment.validLogin_midc;
      // this.sesion.setTitle('Acceder - Mi Datacrédito');
    }
    if (this.sesion.product === 'pntd') {
      this.urlEnv = environment.validLogin_pntd;
      this.sesion.setTitle('Acceder - Ponte al día');
    }
    if (this.sesion.product === 'os') {
      this.sesion.setTitle('Acceder - OneShot');
    }

    metadatosService.etiquetaCanonical(`https://usuario.midatacredito.com/login?product=${this.sesion.product}`);
    this.utilities.getUtmParams();
    
  }

  ngOnInit() {
    

    if(this.sesion.resetLogin){
      this.resetPaso1();
    }
    //$('#intentosOTP').modal('show');
    //console.log(window.navigator.userAgent)
    this.login.loadParameters();
    this.dataLayerService.dl_userId();
    //this.randomBanner()
    let fecha = new Date()
    let mes = fecha.getMonth();
    let dia = fecha.getDate();
    let hora = fecha.getHours();
    //if(mes == 7 && (dia >= 6 && dia <= 9) && (hora >= 16 && hora <= 24)){
    if(mes == 9 && (dia >= 24 && dia <= 24) && (hora >= 21)){
		  this.maintenanceAlert2 = false;
      	this.maintenanceAlert = true;
    }  else {
      this.maintenanceAlert = false;
      this.maintenanceAlert2 = true;		
      if(this.questionPar != undefined){
        this.maintenanceAlert = false;
        this.login.listarPreguntas();
        this.login.paso1 = 0;
        this.login.paso5 = 1;
      }

      if(this.actualizacion == 1) {
        this.maintenanceAlert = false;
        this.login.changePassVar = 1;
        this.login.actualizaDatos = 0;
        this.login.ingActualizaDatos = 1;
      }
    }	
  }

  guardarTerminos(){
    this.login.saveTerms();
  }

  noAceptar(){
    this.login.dontAccept();
  }

  /*** Función que valida los carácteres de la contraseña nueva del usuario ***/
  validar(text:any){
    this.caracteres = (text.length >= 8);
    let upperCase = false;
    let lowerCase = false;
    this.unNumero = false;
    var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    let regex = /^[a-zA-Z]+$/;
    this.unEspecial = format.test(text);

    for (let index = 0; index < text.length; index++) {
      var caracter = text.charAt(index);

      if(!isNaN(caracter * 1)){
        this.unNumero = true;
      }
      else {
        if(regex.test(caracter) && caracter == caracter.toUpperCase()){
          upperCase = true;
        }
        if(regex.test(caracter) && caracter == caracter.toLowerCase()){
          lowerCase = true;
        }
      }
    }
    this.upperLower = (upperCase && lowerCase);
    this.contrasena = text;
  }

  validarConfirm(text:any){
    if(text === this.contrasena){
      //console.log("IGUALES");
    }else{
      //console.log("DIFERENTES");
    }
  }

  /*** Front - Código OTP */
  next(code:any) {
    let res;
    res =this.sesion.setBoxesOtp(this.otpCode,this.prevOtpL,code,'L');
    this.login.codigoOTPBra = res[0]
    this.prevOtpL = [code,res[1]];
    
  }
  trackBy(index:any) {
    return index;
  }
  getImage() {
    return 'assets/images/backgrounds/domina/Curva_Midc_1.svg'
  }
  // randomBanner() {
	//   this.randItems = this.bannerRTD[Math.floor(Math.random() * this.bannerRTD.length)];
  // }

  recordar_contrasena( path: string ){
    //GA4 - forgot_password
    this.dataLayerService.dl_eventoGA4_general('forgot_password');
    
    this.sesion.navigateToRoute( path );
  }
  resetPaso1(){
    this.login.modelPaso1 = {
      tipoDocumento: '1',
      documento: '',
      country: environment.country,
      recaptcha: ''
    };

    this.login.modelPaso2 = {
      password: ''
    };
    this.login.paso1 = 1;
    this.login.paso2 = 0;
    this.sesion.resetLogin=false;
  }

}